import React, { lazy, Suspense } from 'react';

const LazyOrderMembersDTR = lazy(async () => await import('./OrderMembersDTR'));

const OrderMembersDTR = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => (
  <Suspense fallback={null}>
    <LazyOrderMembersDTR {...props} />
  </Suspense>
);

export default OrderMembersDTR;
